export default "__VITE_PUBLIC_ASSET__44581290__"